<template>
  <div class="table-responsive">
    <table class="table-bordered custom-table table-sm align-middle">
      <thead>
        <tr>
          <th rowspan="2">Site Code</th>
          <th v-for="rn in riskNames" :key="rn" :colspan="2">{{ rn }}</th>
        </tr>
        <tr class="dss">
          <template v-for="rn in riskNames" :key="rn + '-sub'">
            <th>Value</th>
            <th>Score</th>
          </template>
</tr>
</thead>

<tbody>
  <tr v-for="row in tableRows" :key="row.siteCode">
    <td>{{ row.siteCode }}</td>
    <template v-for="rn in riskNames" :key="row.siteCode + '-' + rn">
            <td>
              {{ nz(row[rnKey(rn, 'value')]) }}
            </td>
            <td
              class="score-cell"
              :style="{ backgroundColor: colorOrUndef(row, rn) }"
              :title="nz(row[rnKey(rn, 'riskLevelLabel')])"
              @click="openPopup(row.siteCode, rn, row[rnKey(rn, 'score')])"
            >
              {{ nz(row[rnKey(rn, 'score')]) }}
            </td>
          </template>
  </tr>
</tbody>
</table>
</div>
<!-- Modal / Popup -->
 
<customModal
  v-if="showPopup"
  :containerxxl="true"
  :bodyxl="false"
  :footerShow="true"
  @closeModal="closePopup"
>
  <template #title>
    <h4 class="my-0">Risk Assessment Details</h4>
  </template>

  <template #body>

   <div v-if="popupEntries.length === 0" class="rbqm-modal-body">
          <em>No entries found.</em>
        </div>

        <div v-else class="rbqm-modal-body">
          <div class="rbqm-table-wrap">
            <table class="table table-sm table-bordered mb-0">
              <thead>
                <tr>
                  <th v-for="col in popupColumns" :key="col">{{ colnames[col] }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(e, idx) in popupEntries" :key="idx">
                  <td v-for="col in popupColumns" :key="col"
                  :style="col === 'riskLevelLabel' ? { backgroundColor: legendColor || '' } : null">
                    <!-- Friendly date for createdAt; otherwise raw -->
                    <template v-if="col === 'createdAt'">
                      {{ formatDate(e[col]) }}
                    </template>
                    <template v-else>
                      {{ pretty(e[col]) }}
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- <div class="rbqm-legend mt-2" v-if="legendColor">
            <span class="rbqm-chip" :style="{ backgroundColor: legendColor }"></span>
            <small>Risk color: {{ legendColor }}</small>
          </div> -->
        </div>
  </template>

  <template #footer>
    <div class="d-flex justify-content-end">
      <button class="btn btn-outline-danger" @click="closePopup">Close</button>
    </div>
  </template>
</customModal>

</template>
<script>
import customModal from "../customModal/customModal.vue";
export default {
  name: 'RbqmTable',
 components: {
        customModal:customModal,

    },
  props: {
    apiData: { type: Array, required: true },
    includeGlobalRow: { type: Boolean, default: true },
    globalRowLabel: { type: String, default: 'Global' }
  },

  data() {
    return {
      showPopup: false,
      showVisitPopup: false,
      selectedSiteCode: '',
      selectedRiskName: '',
      popupEntries: [],
      legendColor: '',
      colnames: {
        categoryId: 'Category Id',
        impact:'Impact',
        probability:'Probability',
        detectability:'Detectability',
        score:'Score',
        riskLevelLabel:'Risk Level Label',
        value:'Value',
        unit:'Unit',
        executionType:'Execution Type',
        createdAt:'Created At',
       
      }
    };
  },

  computed: {
    sites() {
      const out = [];
      const orphans = [];
      if (Array.isArray(this.apiData)) {
        for (let i = 0; i < this.apiData.length; i++) {
          const item = this.apiData[i];
          if (item && typeof item === 'object') {
            if ('siteCode' in item && Array.isArray(item.risks)) {
              out.push({ siteCode: item.siteCode, risks: item.risks || [] });
            } else if ('riskName' in item) {
              orphans.push(item);
            }
          }
        }
      }
      if (orphans.length && this.includeGlobalRow) {
        out.push({ siteCode: this.globalRowLabel, risks: orphans });
      }
      return out;
    },

    riskNames() {
      const seen = Object.create(null);
      const names = [];
      for (let s = 0; s < this.sites.length; s++) {
        const risks = this.sites[s].risks || [];
        for (let r = 0; r < risks.length; r++) {
          const rn = risks[r] && risks[r].riskName;
          if (rn && !seen[rn]) {
            seen[rn] = true;
            names.push(rn);
          }
        }
      }
      return names;
    },

    tableRows() {
      const rows = [];
      for (let s = 0; s < this.sites.length; s++) {
        const site = this.sites[s];
        const row = { siteCode: site.siteCode };
        for (let j = 0; j < this.riskNames.length; j++) {
          const rn = this.riskNames[j];
          const latest = this.selectLatest(site.risks, rn);
          row[this.rnKey(rn, 'value')] = latest ? this.nz(latest.value) : '';
          row[this.rnKey(rn, 'score')] = latest ? this.nz(latest.score) : '';
          row[this.rnKey(rn, 'riskLevelColor')] = latest ? this.nz(latest.riskLevelColor) : '';
          row[this.rnKey(rn, 'riskLevelLabel')] = latest ? this.nz(latest.riskLevelLabel) : '';
        }
        rows.push(row);
      }
      return rows;
    },

    popupTitle() {
      if (!this.selectedRiskName) return '';
      return `${this.selectedRiskName} @ ${this.selectedSiteCode}`;
    },

    popupColumns() {
      // Prefer a sensible order, but include any other keys present
      const preferred = [
        'categoryId',
        'impact',
        'probability',
        'detectability',
        'score',
        'riskLevelLabel',
        'value',
        'unit',
        'executionType',
        'createdAt',
       
      ];
      const seen = new Set(preferred);
      const cols = [...preferred];

      // for (const e of this.popupEntries) {
      //   for (const k of Object.keys(e || {})) {
      //     if (k === 'riskName' || k === 'siteCode') continue;
      //     if (!seen.has(k)) {
      //       seen.add(k);
      //       cols.push(k);
      //     }
      //   }
      // }
      return cols;
    }
  },

  methods: {
    rnKey(name, field) {
      return name + '__' + field;
    },
    nz(v) {
      return v === null || v === undefined ? '' : v;
    },
    pretty(v) {
      if (v === null || v === undefined) return '';
      if (typeof v === 'object') return JSON.stringify(v);
      return String(v);
    },
    colorOrUndef(row, rn) {
      const c = row[this.rnKey(rn, 'riskLevelColor')];
      return c ? String(c) : undefined;
    },
    selectLatest(risks, riskName) {
      if (!Array.isArray(risks)) return null;
      let latest = null;
      for (let i = 0; i < risks.length; i++) {
        const r = risks[i];
        if (r && r.riskName === riskName) {
          if (!latest) {
            latest = r;
          } else {
            const a = new Date(latest.createdAt || 0).getTime();
            const b = new Date(r.createdAt || 0).getTime();
            if (b >= a) latest = r;
          }
        }
      }
      return latest;
    },

    openPopup(siteCode, riskName, scoreCellValue) {
      // Don’t open when empty score cell
      if (scoreCellValue === null || scoreCellValue === undefined || scoreCellValue === '') return;

      this.selectedSiteCode = siteCode;
      this.selectedRiskName = riskName;

      // Collect *all* entries (history) for this site & risk
      const entries = this.collectEntries(siteCode, riskName);
      // Sort by createdAt desc if present
      entries.sort((a, b) => {
        const ta = new Date(a.createdAt || 0).getTime();
        const tb = new Date(b.createdAt || 0).getTime();
        return tb - ta;
      });

      this.popupEntries = entries;
      // Pick legend color from the latest entry if any
      this.legendColor = (entries.length && entries[0] && entries[0].riskLevelColor)
        ? String(entries[0].riskLevelColor)
        : '';
      this.showPopup = true;
      this.bindEsc();
    },

    closePopup() {
      this.showPopup = false;
      this.unbindEsc();
    },

    collectEntries(siteCode, riskName) {
      const out = [];
      if (!Array.isArray(this.apiData)) return out;

      const isGlobal = siteCode === this.globalRowLabel;

      for (const item of this.apiData) {
        if (!item || typeof item !== 'object') continue;

        // Site-bound risks
        if (!isGlobal && item.siteCode === siteCode && Array.isArray(item.risks)) {
          for (const r of item.risks) {
            if (r && r.riskName === riskName) {
              out.push({ siteCode, ...r });
            }
          }
        }

        // Orphan/global risks
        if (isGlobal && !('siteCode' in item) && item.riskName === riskName) {
          out.push({ siteCode: this.globalRowLabel, ...item });
        }
      }
      return out;
    },

    formatDate(v) {
      if (!v) return '';
      const d = new Date(v);
      if (isNaN(d)) return String(v);
      // e.g., 2025-08-25 14:05
      const pad = (n) => (n < 10 ? '0' + n : n);
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    onKeydown(e) {
      if (e.key === 'Escape') this.closePopup();
    },
    bindEsc() {
      window.addEventListener('keydown', this.onKeydown);
    },
    exporttoexcell() {
      const excelData = this.buildExcelData();
  this.$emit("exporttoexcell", excelData);
    },
    exportPDF() {
      this.$emit("exporttopdf");
    },
    buildExcelData() {
  const headerRow1 = ['Site Code'];
  const headerRow2 = [''];

  this.riskNames.forEach(rn => {
    headerRow1.push(rn, '');
    headerRow2.push('Value', 'Score');
  });

  const dataRows = this.tableRows.map(row => {
    const r = [row.siteCode];
    this.riskNames.forEach(rn => {
      r.push(
        row[this.rnKey(rn, 'value')],
        row[this.rnKey(rn, 'score')]
      );
    });
    return r;
  });

  return [headerRow1, headerRow2, ...dataRows];
},

    
    unbindEsc() {
      window.removeEventListener('keydown', this.onKeydown);
    }
  },

  beforeUnmount() {
    this.unbindEsc();
  }
};
</script>

<style scoped>
.custom-table thead tr th {
  border: 1px solid #a19c9c;
}

/* (fixed) cell selector below: .dss td, not .dss.td */
.dss td {
  border-bottom: 1px solid #ddd;
}

.dss td.highlight {
  border-bottom: 3px solid #2ecc71;
}

/* Make scores look clickable */
.score-cell {
  cursor: pointer;
  user-select: none;
}

/* Modal styles */
.rbqm-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  /* slate-900/45 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.rbqm-modal {
  background: #fff;
  border-radius: 10px;
  width: min(1000px, 96vw);
  max-height: 86vh;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}

.rbqm-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .75rem 1rem;
  border-bottom: 1px solid #eee;
}

.rbqm-title {
  font-size: 1rem;
}

.rbqm-sub {
  color: #666;
  margin-left: .4rem;
}

.rbqm-close {
  border: none;
  background: transparent;
  font-size: 1.15rem;
  line-height: 1;
  cursor: pointer;
}

.rbqm-modal-body {
  padding: .75rem 1rem;
  overflow: auto;
}

.rbqm-table-wrap {
  overflow: auto;
  max-height: 60vh;
  border: 1px solid #eee;
  border-radius: 8px;
}

.rbqm-legend .rbqm-chip {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  margin-right: .5rem;
  vertical-align: middle;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.rbqm-modal-footer {
  padding: .6rem 1rem;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
}
.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 56px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(124px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.plan-side-popup > div {
  cursor: pointer;
  padding: 0.5rem;
}

.plan-side-popup > div:hover {
  background-color: #e4eaf9;
}
.biggerfont {
  font-size: 16px;
}
</style>
